import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function DoneIcon({ ...props }) {
  return (
    <SvgIcon width="26" height="25" viewBox="0 0 26 25" {...props}>
      <path
        d="M9.40439 25C8.59895 25 7.83112 24.6537 7.30398 24.0477L0.665808 16.412C-0.328232 15.2683 -0.193856 13.547 0.96615 12.5669C2.12564 11.5858 3.87142 11.7182 4.86664 12.8625L9.20632 17.8541L22.9219 1.54743C25.0451 -1.38467 27.2672 0.239004 25.1347 3.18364L11.6548 23.8579C11.1602 24.5402 10.3752 24.9602 9.52613 24.9972C9.48514 24.9989 9.4448 25 9.40439 25Z"
        fill="#00A344"
      />
    </SvgIcon>
  );
}
